import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { WorkFlowMessageModel } from 'src/app/models/commissionsummary/workflowmessage.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ApprovalFlowService } from '../approval-flow-models/approval-flow.service';
import { WorkflowTicket } from '../approval-flow-models/workflow-ticket.model';

@Component({
  selector: 'app-ticket-process',
  templateUrl: './ticket-process.component.html',
  styleUrls: ['./ticket-process.component.css']
})

export class TicketProcessComponent implements OnInit {
  ticketModelData: WorkflowTicket;
  pendingTickets: WorkflowTicket[];
  contentMessage: WorkFlowMessageModel;
  updateTicket: WorkflowTicket;
  ticketLevels: WorkflowTicket[];
  ticketsList: WorkflowTicket[];
  filterTicketList: WorkflowTicket[];
  updateFilterTickts: WorkflowTicket[] = [];
  public displayedColumns = [];
  public displayedData = [];
  contentMsgData: any;
  contentMsg: string = "";
  public isFinalStausPending: boolean;

  constructor(private approvalFlowService: ApprovalFlowService, private router: Router,
    private authGurdService: AuthGaurdService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.ticketModelData = this.approvalFlowService.pendingWorkflowTicket;

    this.approvalFlowService.getContentMessage(this.approvalFlowService.pendingWorkflowTicket.trackingId)
      .subscribe((response: WorkFlowMessageModel) => {
        this.contentMessage = response;
        console.log(this.contentMessage[0].message_content);

        this.contentMsgData = this.parseXmlToJson(this.contentMessage[0].message_content);
        this.displayedColumns = Object.keys(this.contentMsgData).map(k => k);
        this.displayedData = Object.values(this.contentMsgData).map(k => k);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

    this.init();
  }

  init() {
    this.findPendingTicketByTrackingId(this.approvalFlowService.pendingWorkflowTicket.trackingId);
  }

  findPendingTicketByTrackingId(trackingId: string) {
    console.log("findPendingTicketByTrackingId called: " + trackingId);
    this.approvalFlowService.findPendingTickets(trackingId)
      .subscribe((data: WorkflowTicket[]) => {
        console.log(JSON.stringify(data));
        let i = 0;
        for (let ticket of data) {
          i++;
          console.log(i);
          console.log(ticket.status);
          if (ticket.status != null && ticket.status === 'Pending') {
            ticket.isStausPending = true;
          }
          console.log(ticket.final_status);
          if (ticket.final_status != null && ticket.final_status === 'Approved') {
            this.isFinalStausPending = false;
          } else if (ticket.final_status != null && ticket.final_status === 'Rejected') {
            this.isFinalStausPending = false;
          } else {
            this.isFinalStausPending = true;
          }

        }
        this.pendingTickets = data;
        console.log(this.pendingTickets);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  addComment(pendingTicket: WorkflowTicket) {
    console.log(pendingTicket);

    this.updateTicket = pendingTicket;
  }

  approvalCheck() {
    console.log(this.updateTicket);
    if (this.updateTicket) {
      //console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));
      //console.log(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'));

      if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
        this.approve();
      } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
        this.notificationService.notify(NotificationType.ERROR, `No Privilages to Approve`);
      } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor" && localStorage.getItem('CURRENT_EMPLOYEEID_SESSION') === this.updateTicket.submitted_by) {
        this.notificationService.notify(NotificationType.ERROR, `You can not approve yourself`);
      } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor" && this.updateTicket.approval_from === "ADMIN") {
        this.notificationService.notify(NotificationType.ERROR, `No Privilages to Approve`);
      } else {
        this.approve();
      }

    } else {
      this.notificationService.notify(NotificationType.ERROR, `Please enter comment`);
    }
  }

  rejectCheck() {
    if (this.updateTicket) {
      console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));
      console.log(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'));

      if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
        this.reject();
      } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "") {
        this.notificationService.notify(NotificationType.ERROR, `No Privilages to Approve`);
      } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor" && localStorage.getItem('CURRENT_EMPLOYEEID_SESSION') === this.updateTicket.submitted_by) {
        this.notificationService.notify(NotificationType.ERROR, `You can not approve yourself`);
      } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor" && this.updateTicket.approval_from === "ADMIN") {
        this.notificationService.notify(NotificationType.ERROR, `No Privilages to Approve`);
      } else {
        this.reject();
      }

    } else {
      this.notificationService.notify(NotificationType.ERROR, `Please enter comment`);
    }

    //this.reject();
  }

  approve() {
    if (this.updateTicket) {
      console.log(this.updateTicket);
      this.updateTicket.status = 'Approved';
      this.updateTicket.approved_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.updateTicket.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      //this.updateTicket.approval_from = 'N/A';
      this.updateTicket.update_dt = new Date();
      this.approvalFlowService.updateWorkflowTicket(this.updateTicket).subscribe
        (response => {
          response = response as ErrorResponseMessage;
          this.notificationService.notify(NotificationType.SUCCESS, `Approved successfully`);
          //this.findDistinctLevels(this.updateTicket.trackingId);
          this.updateTicket = null;
          this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    } else {
      this.notificationService.notify(NotificationType.ERROR, `Please add the comment`);
    }

  }

  reject() {
    if (this.updateTicket) {
      this.updateTicket.status = 'Rejected';
      this.updateTicket.update_dt = new Date();
      this.updateTicket.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.approvalFlowService.updateWorkflowTicket(this.updateTicket).subscribe
        (response => {
          response = response as ErrorResponseMessage;
          this.notificationService.notify(NotificationType.SUCCESS, `Rejected`);
          this.init();
        },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.notify(NotificationType.ERROR, errorResponse.error.message);
          })
    }
    else {
      this.notificationService.notify(NotificationType.ERROR, `Please add the comment`);
    }
  }

  findDistinctLevels(trackingId: string) {
    this.approvalFlowService.getTicetLevelsAndStages(trackingId)
      .subscribe((data: WorkflowTicket[]) => {
        this.ticketLevels = data;
        if (this.ticketLevels.length > 0) {
          for (let filterTkt of this.ticketLevels) {
            filterTkt.status = 'Pending';
            status = filterTkt.status;
            this.updateFilterTickts.push(filterTkt);
          }
          if (this.updateFilterTickts.length > 0) {
            this.approvalFlowService.updateWorkflowTickets(this.updateFilterTickts).subscribe
              (response => {
                response = response as ErrorResponseMessage;
                this.notificationService.notify(NotificationType.SUCCESS, `Next level or stage moved to pending`);
                this.redirect('ticket-approvals')
              },
                (errorResponse: HttpErrorResponse) => {
                  this.notificationService.notify(NotificationType.ERROR, errorResponse.error.message);
                })
          }
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  findTicketsByTrackingId(trackingId: string) {
    this.approvalFlowService.findPendingTickets(trackingId)
      .subscribe((data: WorkflowTicket[]) => {
        this.ticketsList = data;
        let status = null;
        console.log(this.ticketLevels);
        console.log(this.ticketsList);
        for (let ticketlevel of this.ticketLevels) {

          this.filterTicketList = this.ticketsList.filter(ticket => ticket.level === ticketlevel.level &&
            ticket.stage === ticketlevel.stage);

          if (this.filterTicketList.length > 0) {
            for (let filterTkt of this.filterTicketList) {
              if (!filterTkt.status) {
                filterTkt.status = 'Pending';
                status = filterTkt.status;
                this.updateFilterTickts.push(filterTkt);
              }

            }
            if (this.updateFilterTickts.length > 0) {
              this.approvalFlowService.updateWorkflowTickets(this.updateFilterTickts).subscribe
                (response => {
                  response = response as ErrorResponseMessage;
                  this.notificationService.notify(NotificationType.SUCCESS, `Next level or stage moved to pending`);
                }, (errorResponse: HttpErrorResponse) => {
                  var msg: any;
                  msg = errorResponse;
                  this.notificationService.sendNotification(NotificationType.ERROR, msg);
                })
              break;

            }

          }
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  parseXmlToJson(xml) {
    const json = {};
    for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
      const key = res[1] || res[3];
      const value = res[2] && this.parseXmlToJson(res[2]);
      json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;

    }
    return json;
  }

}
